import React, { createContext, useContext, useEffect } from "react";

import type { ChatMessage, UserRole } from "../hooks/useChat";
import { useChat } from "../hooks/useChat";

interface ChatContextType {
  messages: ChatMessage[];
  loading: boolean;
  error: string;
  userRole: UserRole;
  isOpen: boolean;
  onSubmit: (query: string) => void;
  clearMessages: () => void;
  setUserRole: (role: UserRole) => void;
  toggleChat: () => void;
}

const ChatContextValue = createContext<ChatContextType | null>(null);

export const useChatContext = () => {
  const context = useContext(ChatContextValue);

  if (!context) {
    throw new Error("useChatContext must be used within a ChatContext");
  }

  return context;
};

interface ChatContextProps {
  children: React.ReactNode;
}

export function ChatContext({ children }: ChatContextProps) {
  const chatState = useChat();

  useEffect(() => {
    document.body.classList.toggle("chat_open", chatState.isOpen);
    return () => document.body.classList.remove("chat_open");
  }, [chatState.isOpen]);

  return <ChatContextValue.Provider value={chatState}>{children}</ChatContextValue.Provider>;
}
